import { mapState } from 'vuex'
import PromiseWorker from '@/utils/PromiseWorker'
import CartWorker from 'worker-loader?name=order-lines.worker.js!../utils/order-lines.worker.js'

export default {
  data() {
    return {
      sortedOrderLines: null
    }
  },
  computed: {
    ...mapState('user', {
      userClientToken: 'client_token'
    })
  },
  watch: {
    async orderLines() {
      this.sortedOrderLines = await this.getSortedOrderLines(this.orderLines, this.userClientToken)
    }
  },
  async created() {
    this.worker = new PromiseWorker(new CartWorker())

    if (this.orderLines) {
      this.sortedOrderLines = await this.getSortedOrderLines(this.orderLines, this.userClientToken)
    }
  },
  beforeDestroy() {
    this.worker.destroy()
  },
  methods: {
    async getSortedOrderLines(orderLines, userClientToken) {
      return await this.worker.postMessage({ orderLines, userClientToken })
    }
  }
}
